import type { I18nFn } from '#/i18n/types/I18nFn';
import type { SearchFacetData } from '#/modules/search/types/SearchFacetData';
import { EMPLOYMENT_TYPES } from '#/utils/constants/general/employmentTypes';

export function employmentTypeFacet(i18n: I18nFn) {
  return {
    id: 'employmentTypeFacet',
    name: 'jobType',
    get title() {
      return i18n('Job Type');
    },
    type: 'array',
    options: Object.keys(EMPLOYMENT_TYPES(i18n)),
    optionTitles: EMPLOYMENT_TYPES(i18n),
  } as const satisfies SearchFacetData;
}
